/**
 * Created by Z179603 on 7/17/2016.
 */

'use strict';
angular.module('cvsApp').service('paymentAppData', function () {

    function paymentAppData() {

        var paymentAppData = {
            "serviceEndPoints": {
                "getSpecialtyWCMContent": "specialty/getSpecialtyWCMContent",
                "getSpecialtyConfig":"specialty/getSpecialtyConfig"
            },
            // following is just to keep the names of services, key has to be same as values
            "serviceNames": {
                "getSpecialtyWCMContent": "getSpecialtyWCMContent",
                "getSpecialtyConfig":"getSpecialtyConfig"
            },
            "serviceNameEnv":{
             //getSpecialtyWCMContent:"dev1"
            }
        };

        return paymentAppData;
    }


    return new paymentAppData();
});



